/* eslint-disable max-len */
import moment from 'moment';
import React from 'react';
import SummaryDetailsCover from '../../../components/SummaryDetailsCover';
import { getOrdinalNumber, getRepaymentStatus, isLoanScheduleDueForDebit } from '../../../utils/helpers';
import RepaymentDetailsCard from './RepaymentDetailsCard';
import './RepaymentSchdule.scss';

interface IRepaymentSchedule{
  payload:any;
  refetchLoan?:any;
}
const RepaymentSchedule = ({ payload, refetchLoan }:IRepaymentSchedule) => (
  <div className="loan-repayment-schedule">
    <SummaryDetailsCover paddingBottom="0px">
      <div className="loan-repayment-title">
        Repayments
      </div>
      <div className="row">
        {
          payload?.loanSchedules?.map((ele, index) => (
            <RepaymentDetailsCard
              firstName={payload?.firstName}
              amountDue={ele?.amountDue}
              index={index + 1}
              installmentNumber={getOrdinalNumber(index + 1)}
              loanScheduleId={isLoanScheduleDueForDebit(ele, payload)}
              status={getRepaymentStatus(ele?.dueDate, ele?.isFullyPaid)}
              dueDate={moment(ele?.dueDate).format('MMM DD, YYYY')}
              refetchLoan={refetchLoan}
              id={ele?.id}
            />
          ))
        }

      </div>
    </SummaryDetailsCover>
  </div>
);
export default RepaymentSchedule;
